module.exports = __webpack_public_path__ + "img/michael.0591d8aa.png";